<tokens-browser-device [device]="device" (newDevice)="onNewDevice($event)" (back)="onBack($event)"> </tokens-browser-device>
